// extracted by mini-css-extract-plugin
export var fadeIn = "_dj-1";
export var modalContent = "_dj-3";
export var overlay = "_dj-0";
export var popoverContent = "_dj-2";
export var results = "_dj-5";
export var searchInputWrapper = "_dj-4";